import React, { PropsWithChildren } from "react";
import { styled } from "@mui/material";
import UploadModelBtn from "./UploadModelBtn";
import UploadIcon from "@/components/icons/Upload";
import SupportedRevitVersions from "./SupportedRevitVersions";
import t from '@/utils/translate';

const Rect = styled('div')({
  width: '240px',
  height: '204px',
  padding: '16px',
  gap: '16px',
  borderRadius: '12px',
  border: 'dashed 1px #6B778C',
  margin: 'auto',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

const Info = styled('p')`
  font-size: 13px;
  font-weight: 400;
  line-height: 15.23px;
  text-align: center;
  padding: 0px;
  margin: 0px;
  color: #091E42;
`;

const Comment = styled(Info)`
  color: #6B778C;
`;

export type NoModelsPlaceholderProps = {
  onBtnClick: () => void;
} & PropsWithChildren;

export default ({ onBtnClick, children }: NoModelsPlaceholderProps) => {
  return (
    <Rect>
      <UploadIcon style={{ width: '24px', height: '24px' }}/>
      <Info>{t('model.hint.dragFiles', true)}</Info>
      <UploadModelBtn onClick={onBtnClick} />
      <Comment><SupportedRevitVersions /></Comment>
      {children}
    </Rect>
  );
}